import { Authenticator } from "@aws-amplify/ui-react";

import { Header } from "../components/Login/Header";
import { SignInHeader } from "../components/Login/SignInHeader";
import { SignInFooter } from "../components/Login/SignInFooter";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";

import "../assets/css/amplify-styles.css";
import { Button } from "@mui/material";
import { Typography } from "@mui/material";
import { Auth } from "aws-amplify";

var image = require("../assets/login-img/LoginBackground.jpg");
//   var logo = require('../img/LoginLogo.png')

const components = {
  Header,
  SignIn: {
    Header: SignInHeader,
    Footer: SignInFooter,
  },
  // Footer
};

export function Login(props) {
  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      height="100vh"
      objectfit="cover"
      sx={{
        backgroundImage: `url(${image})`,
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center center",
      }}
    >
      <Grid
        container
        rowSpacing={1}
        justifyContent="center"
        direction="column"
        alignItems="center"
        style={{
          display: "flex",
          backgroundColor: "white",
          width: "30%",
          height: "40%",
          borderRadius: "15px",
          boxShadow: "15px 15px 15px rgb(255, 255, 255, 0.5)",
        }}
      >
        <Typography
          fontSize={"150%"}
          textAlign={"center"}
          fontWeight={"800"}
          color={"#3c3c3c"}
          marginBottom={"10%"}
          marginX={"5%"}
        >
          Sign in using your Azure account
        </Typography>
        <Button
          variant="contained"
          style={{
            width: "55%",
            height: "15%",
            backgroundColor: "#c29040",
            fontWeight: "bold",
            borderRadius: "15px",
          }}
          onClick={() => props.ssoSignIn()}
        >
          Sign In
        </Button>
      </Grid>
    </Box>
  );
}
